module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"audit_process_title":"Fortschritt des Audits","audit_process_info":"{current} von {total} Fragen bearbeitet"},"en":{"audit_process_title":"Progress in audit","audit_process_info":"{current} of {total} questions finished"}}')
  delete Component.options._Ctor
}
